import { render, staticRenderFns } from "./CtrlAttachment.vue?vue&type=template&id=d0706edc&scoped=true&"
import script from "./CtrlAttachment.vue?vue&type=script&lang=ts&"
export * from "./CtrlAttachment.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlAttachment.vue?vue&type=style&index=0&id=d0706edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0706edc",
  null
  
)

export default component.exports